module.exports = __webpack_public_path__ + "static/media/wizualizacja-145.03aa0cdf.png";